import { boot as reduxBoot } from './redux/store'

export const boot = () => reduxBoot()
